import { Link } from "react-router-dom";

const NotFound = () => {
	return (
		<>
			<h1>Not Found</h1>
			<p>Could not find the requested resource.</p>
			<Link to="/">Return Home</Link>
		</>
	);
};

export default NotFound;